module.exports = __webpack_public_path__ + "img/expovina-primavera_04.b8e68bfe.jpg";